<template>
	<v-container class="text-center">
		<DialogConfirm
			:titulo="`${isOwner ? `Excluir` : `Sair do`} Grupo`"
			icon="mdi-delete-outline"
			:texto="`Você tem certeza que deseja ${
				isOwner ? `excluir o` : `sair do`
			} grupo ${grupo.nome_grupo}`"
			:botao="`${isOwner ? `Excluir` : `Sair do`} Grupo`"
			:confirmado="excluirGrupo"
		>
		</DialogConfirm>
		<BtnAdicionarGrupo
			class="mt-2"
			v-if="isAdmin"
			:reload-integrantes="reloadGrupo"
			:id-grupo="grupo.id"
			:integrantes="grupo.integrantes"
		></BtnAdicionarGrupo>
		<v-expansion-panels flat accordion open-on-hover elevation="1" class="mt-2">
			<v-expansion-panel>
				<v-expansion-panel-header>
					<h2 class="text-center">Administradores</h2>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-list style="width: 100%">
						<v-list-item
							v-for="a in grupo.administradores"
							:key="a.directus_users_id.id"
						>
							<v-list-item-avatar>
								<v-img
									max-width="40px"
									height="40px"
									class="rounded-circle"
									cover
									:src="
										a.directus_users_id.avatar
											? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}`
											: require(`../assets/icon-person.svg`)
									"
								/>
							</v-list-item-avatar>
							<v-list-item-content>
								<v-list-item-title
									class="d-flex text-subtitle-2"
									style="white-space: inherit"
								>
									<router-link
										:to="`/painel/u/${a.directus_users_id.id}/${sanitizeTitle(
											a.directus_users_id.first_name
										)}`"
										class=""
									>
										{{ a.directus_users_id.first_name }}
										{{
											a.directus_users_id.last_name !== null
												? a.directus_users_id.last_name
												: ''
										}}
									</router-link>
								</v-list-item-title>
								<v-list-item-subtitle>
									<v-btn
										disabled
										x-small
										class="d-flex justify-start text-left"
										outlined
										v-if="isOwner && user.id == a.directus_users_id.id"
									>
										Proprietário
									</v-btn>
									<v-btn
										v-if="isOwner && user.id !== a.directus_users_id.id"
										@click="excluirAdmin(a.id)"
										class="pa-0"
										text
										x-small
										style="cursor: pointer"
									>
										<v-icon small>mdi-close</v-icon> Remover Administrador
									</v-btn>
								</v-list-item-subtitle>
							</v-list-item-content>
						</v-list-item>
					</v-list>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header>
					<h2 class="text-center">Integrantes</h2>
				</v-expansion-panel-header>
				<v-expansion-panel-content>
					<v-list>
						<v-hover
							v-slot="{ hover }"
							v-for="a in integrantes"
							:key="a.directus_users_id.id"
							v-show="!isInAdmin(a.directus_users_id.id)"
						>
							<v-list-item>
								<v-list-item-avatar>
									<v-img
										max-width="40px"
										height="40px"
										class="rounded-circle"
										cover
										:src="
											a.directus_users_id.avatar
												? `https://api.mylegis.com.br/assets/${a.directus_users_id.avatar}`
												: require(`@/assets/icon-person.svg`)
										"
									/>
								</v-list-item-avatar>
								<v-list-item-content class="d-flex flex-row">
									<v-list-item-title
										class="d-flex text-subtitle-2"
										style="white-space: inherit"
									>
										<router-link
											:to="`/painel/u/${a.directus_users_id.id}/${sanitizeTitle(
												a.directus_users_id.first_name
											)}`"
											class=""
										>
											{{ a.directus_users_id.first_name }}
											{{
												a.directus_users_id.last_name !== null
													? a.directus_users_id.last_name
													: ''
											}}
										</router-link>
									</v-list-item-title>
									<v-list-item-subtitle
										v-if="isAdmin && hover"
										@click="tornarAdmin(a.directus_users_id.id)"
									>
										<v-btn x-small>
											<v-icon small>mdi-account-star-outline</v-icon>Tornar
											Administrador
										</v-btn>
									</v-list-item-subtitle>
								</v-list-item-content>
								<v-list-item-action>
									<v-icon
										v-if="isAdmin"
										small
										@click="excluirIntegrante(a.id)"
										>mdi-delete</v-icon
									><br />
								</v-list-item-action>
							</v-list-item>
						</v-hover>
					</v-list>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
	</v-container>
</template>

<script>
	import BtnAdicionarGrupo from '../components/BtnAdicionarGrupo.vue';
	import DialogConfirm from '../components/DialogConfirm.vue';

	export default {
		name: 'GroupSideBar',
		components: {
			BtnAdicionarGrupo,
			DialogConfirm,
		},
		data() {
			return {
				edit: {},
				loadingEdit: false,
				showEditGroup: false,
				grupo: { administradores: [] },
				integrantes: [],
			};
		},
		computed: {
			isAdmin() {
				return !!this.grupo.administradores.find(
					(e) => e.directus_users_id.id === this.$store.state.user.id
				);
			},
			isOwner() {
				return this.grupo.user_created === this.$store.state.user.id;
			},
			user() {
				return this.$store.state.user;
			},
		},
		mounted() {
			this.reloadGrupo();
		},
		methods: {
			async updateGroup() {
				await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
					nome_grupo: this.edit.nome_grupo,
				});
				this.edit = {};
				this.loadingEdit = false;
				this.showEditGroup = false;
				this.reloadGrupo();
			},
			isInAdmin(id) {
				let eh = this.grupo.administradores.find(
					(e) => e.directus_users_id.id === id
				);
				return eh !== undefined;
			},
			async excluirGrupo() {
				if (!this.isOwner) {
					let integrante = this.grupo.integrantes.filter(
						(e) => e.directus_users_id.id === this.user.id
					);
					this.excluirIntegrante(integrante[0].id, true);
					return;
				}
				await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
					status: 'archived',
				});
				this.$router.go(-1);
			},
			async tornarAdmin(id) {
				await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
					administradores: {
						create: [
							{
								directus_users_id: { id: id },
								grupos_id: this.$route.params.id_grupo,
							},
						],
					},
				});
				this.reloadGrupo();
			},
			async excluirAdmin(id) {
				await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
					administradores: { delete: [id] },
				});
				this.reloadGrupo();
			},
			async excluirIntegrante(id, admin) {
				await this.$http.patch(`items/grupos/${this.$route.params.id_grupo}`, {
					integrantes: { delete: [id] },
				});
				this.reloadGrupo();

				if (admin) this.$router.go(-1);
			},
			reloadGrupo() {
				this.$http
					.get(
						'items/grupos/' +
							this.$route.params.id_grupo +
							'?fields=integrantes.*,administradores.*,administradores.directus_users_id.*,integrantes.directus_users_id.*,*'
					)
					.then((res) => {
						this.grupo = res.data.data;
						if (this.grupo.adminsitradores) {
							this.integrantes = this.grupo.integrantes.filter(
								(el) =>
									!this.grupo.administradores.find(
										(e) => e.directus_users_id.id === el.directus_users_id.id
									)
							);
						} else this.integrantes = this.grupo.integrantes;
					});
			},
			sanitizeTitle: function (title) {
				var slug = '';
				// Change to lower case
				var titleLower = title.toLowerCase();
				// Letter "e"
				slug = titleLower.replace(/e|é|è|ẽ|ẻ|ẹ|ê|ế|ề|ễ|ể|ệ/gi, 'e');
				// Letter "a"
				slug = slug.replace(/a|á|à|ã|ả|ạ|ă|ắ|ằ|ẵ|ẳ|ặ|â|ấ|ầ|ẫ|ẩ|ậ/gi, 'a');
				// Letter "o"
				slug = slug.replace(/o|ó|ò|õ|ỏ|ọ|ô|ố|ồ|ỗ|ổ|ộ|ơ|ớ|ờ|ỡ|ở|ợ/gi, 'o');
				// Letter "u"
				slug = slug.replace(/u|ú|ù|ũ|ủ|ụ|ư|ứ|ừ|ữ|ử|ự/gi, 'u');
				// Letter "d"
				slug = slug.replace(/đ/gi, 'd');
				// Trim the last whitespace
				slug = slug.replace(/\s*$/g, '');
				// Change whitespace to "-"
				slug = slug.replace(/\s+/g, '-');
				return slug;
			},
		},
	};
</script>

<style scoped>
	a {
		text-decoration: none;
		color: black;
	}

	a:hover {
		text-decoration: underline;
		color: #f15a24;
	}
	h2 {
		font-family: 'Inter';
		font-weight: bold;
		color: #707070;
		text-align: left;
	}

	.filesButton {
		text-decoration: none !important;
	}

	.annotation {
		border: 1px solid rgb(200 200 200) !important;
		margin: 8px 0px;
		border-radius: 10px;
	}

	.annotation ::v-deep img,
	.comentario ::v-deep img {
		max-width: 100% !important;
	}

	.annotation ::v-deep iframe {
		height: 250px;
	}

	.annotationText div {
		width: 100%;
	}

	.reg {
		border: 1px dashed gray;
		border-radius: 10px;
		padding: 5px;
	}
</style>
